module.exports = __webpack_public_path__ + "static/img/05-JM-type.f08cdb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/05-JM-type.jpg
// module id = ypkd
// module chunks = 12